import { Token } from '../shared/types';
import { UserInfo } from './types';

export const getBrowserTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

const getUtcOffset = (timeZone: string, date: Date) => {
  try {
    return new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'longOffset' })
      .formatToParts(date)
      .find(({ type }) => type === 'timeZoneName')?.value;
  } catch {
    return undefined;
  }
};

/**
 * Zone ids from RestaurantSearch are not uniform (e.g. `America/Kentucky/Louisville`
 * and `America/New_York` describe the same wall clock), so the current offsets are
 * compared rather than the ids. Zones that agree right now show the same time of day,
 * which is all the banner warns about, even if they diverge in another season.
 */
export const isTimezoneMismatched = (restaurantTimeZone?: string) => {
  if (!restaurantTimeZone) {
    return false;
  }

  const browserTimeZone = getBrowserTimezone();
  if (browserTimeZone === restaurantTimeZone) {
    return false;
  }

  const now = new Date();
  const browserOffset = getUtcOffset(browserTimeZone, now);
  const restaurantOffset = getUtcOffset(restaurantTimeZone, now);

  return !browserOffset || !restaurantOffset || browserOffset !== restaurantOffset;
};

export const mapTokenToUserInfo = (token: Token): UserInfo => {
  const permissions = token.cfa_perms?.CMT ?? {};
  const type = Object.keys(permissions)[0] ?? '';
  return {
    name: `${token.nickname ?? ''} ${token.family_name ?? ''}`,
    email: token.email ?? '',
    cfaAud: token.cfa_aud ?? '',
    cfaGuid: token.cfa_guid ?? '',
    permissions,
    type,
    locationNumbers: permissions[type as keyof typeof permissions],
  };
};
